import { map } from 'lodash';

import GenericDB from './generic-db';

export default class UsersClientsDB extends GenericDB {
  constructor() {
    super('usersClients');
  }

  /**
   * Delete all usersClients relationships associated with a specific client
   * @param {*} clientId
   */
  async deleteByClient(clientId) {
    const clients = await this.readAll([['client', '==', clientId]]);

    if (!clients.length) {
      return;
    }

    const deleteActions = map(clients, async (client) => {
      await this.delete(client.id);
    });
    return Promise.all(deleteActions);
  }
}
